var DateTimePickerViewModel;

DateTimePickerViewModel = (function() {
  function DateTimePickerViewModel(options) {
    options = $.extend({
      dateTime: ko.observable(moment().add(1, 'days'))
    }, options);
    this.hourOptions = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24];
    this.minuteOptions = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59];
    this.zoneOptions = [
      {
        display: "UTC-12:00",
        value: -720
      }, {
        display: "UTC-11:00",
        value: -660
      }, {
        display: "UTC-10:00",
        value: -600
      }, {
        display: "UTC-9:00",
        value: -540
      }, {
        display: "UTC-8:00",
        value: -480
      }, {
        display: "UTC-7:00",
        value: -420
      }, {
        display: "UTC-6:00",
        value: -360
      }, {
        display: "UTC-5:00",
        value: -300
      }, {
        display: "UTC-4:00",
        value: -240
      }, {
        display: "UTC-3:00",
        value: -180
      }, {
        display: "UTC-2:00",
        value: -120
      }, {
        display: "UTC-1:00",
        value: -60
      }, {
        display: "UTC",
        value: 0
      }, {
        display: "UTC+1:00",
        value: 60
      }, {
        display: "UTC+2:00",
        value: 120
      }, {
        display: "UTC+3:00",
        value: 180
      }, {
        display: "UTC+4:00",
        value: 240
      }, {
        display: "UTC+5:00",
        value: 300
      }, {
        display: "UTC+6:00",
        value: 360
      }, {
        display: "UTC+7:00",
        value: 420
      }, {
        display: "UTC+8:00",
        value: 480
      }, {
        display: "UTC+9:00",
        value: 540
      }, {
        display: "UTC+10:00",
        value: 600
      }, {
        display: "UTC+11:00",
        value: 660
      }, {
        display: "UTC+12:00",
        value: 720
      }
    ];
    this.datepickerOptions = {
      prevText: '',
      nextText: ''
    };
    this.padNumber = function(value) {
      if (value < 10) {
        return "0" + value;
      } else {
        return value;
      }
    };
    this.sourceDateTime = ko.asObservable(options.dateTime);
    if (!this.sourceDateTime()._isAMomentObject) {
      throw 'The date-time-picker expects the dateTime value to be a momentjs object.';
    }
    this.dateValue = ko.observable(this.sourceDateTime().format("MM/DD/YYYY"));
    this.zoneValue = ko.observable(this.sourceDateTime().utcOffset());
    this.hourValue = ko.observable(this.sourceDateTime().hour());
    this.minuteValue = ko.observable(this.sourceDateTime().minute());
    this.zoneValue.subscribe((function(_this) {
      return function(newValue) {
        _this.sourceDateTime().utcOffset(newValue, true);
        _this.sourceDateTime.notifySubscribers();
      };
    })(this));
    this.hourValue.subscribe((function(_this) {
      return function(newValue) {
        _this.sourceDateTime().hour(newValue);
        _this.sourceDateTime.notifySubscribers();
      };
    })(this));
    this.minuteValue.subscribe((function(_this) {
      return function(newValue) {
        _this.sourceDateTime().minute(newValue);
        _this.sourceDateTime.notifySubscribers();
      };
    })(this));
    this.dateValue.subscribe((function(_this) {
      return function(newValue) {
        var newMoment;
        newMoment = moment(newValue, 'MM/DD/YYYY');
        newMoment.utcOffset(_this.zoneValue());
        _this.sourceDateTime().utcOffset(_this.zoneValue(), true);
        _this.sourceDateTime().date(newMoment.date());
        _this.sourceDateTime().month(newMoment.utc().month());
        _this.sourceDateTime().year(newMoment.year());
        _this.sourceDateTime.notifySubscribers();
      };
    })(this));
    this.sourceDateTime.subscribe((function(_this) {
      return function(newDateTime) {
        if (newDateTime) {
          _this.zoneValue(newDateTime.utcOffset());
          _this.minuteValue(newDateTime.minute());
          _this.hourValue(newDateTime.hour());
          _this.dateValue(newDateTime.format('MM/DD/YYYY'));
        }
      };
    })(this));
    this.localTimePreview = ko.computed((function(_this) {
      return function() {
        var clone, currentOffset;
        clone = _this.sourceDateTime().clone();
        currentOffset = moment().utcOffset();
        return clone.utcOffset(currentOffset).format('ddd, MMM D, YYYY hh:mm A ([UTC]Z)');
      };
    })(this));
  }

  return DateTimePickerViewModel;

})();
